
import _ from 'lodash'

export default {
    props: {
        value: {
            type: [String, Number],
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: 'Search & Select Client',
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        searchable: {
            type: Boolean,
            default: true,
        },
        internalSearch: {
            type: Boolean,
            default: false,
        },
        showNoOptions: {
            type: Boolean,
            default: false,
        },
        allowEmpty: {
            type: Boolean,
            default: true,
        },
        helpText: {
            type: String,
            default: null,
        },
        excludeIds: {
            type: Array,
            default: null
        }
    },
    data () {
        return {
            selectableOptions: [],
            clientValue: null,
        }
    },
    async fetch () {
        const query = this.query || ''
        const { items } = await this.$api.searchClients({ query, exclude_ids: this.excludeIds })
        this.selectableOptions = items || []
    },
    watch: {
        value () {
            if (!_.isEqual(parseInt(this.value), this.clientValue?.id)) {
                this.updateValue()
            }
        },
        clientValue (cv1, cv2) {
            this.emitInput()
        },
    },
    mounted () {
        this.updateValue()
    },
    methods: {
        async updateValue () {
            if (this.value) {
                const { survey } = await this.$api.getClient({ id: this.value })
                this.clientValue = survey
            } else {
                this.clientValue = null
            }
        },
        emitInput () {
            this.$emit('input', this.clientValue?.id || null)
            this.$emit('input-raw', this.clientValue || null)
        },
        search (query) {
            this.query = query
            return this.$fetch()
        },
    },
}
